import { useNoteNames } from "../../Project/ProjectStore"
import { Music } from "../../Util/Music/Music"
import { TonicSelector } from "../../Util/TonicSelector/TonicSelector"
import './LinearKey.scss'

export function LinearKey(props:{tonic:number, hilitedNote:number|undefined, repeatRoot?:boolean}){
    const noteNames:string[] = useNoteNames()
    const tonics:number[] = Music.getKeyScale(props.tonic, props.repeatRoot)
    const getNoteCells = () => {
            
            const cells:JSX.Element[] = []
            tonics.forEach((tonic:number, index:number)=>{
                const noteName:string = noteNames[tonic]
                const isHilited:boolean = (index === props.hilitedNote)
                const className:string = (isHilited) ? 'hilited' : ''
                cells.push(<td key={index} className={className + ' linear-note-name'}>{noteName}</td>)
            })
            return cells
        }
        const getPositionCells = () => {
            const cells:JSX.Element[] = []
            for(let i = 0; i < tonics.length; i++){
                const className:string = (i === props.hilitedNote) ? 'hilited' : ''
                const position:string = String((i % 7) + 1)
                cells.push(<td key={i} className={className + ' linear-note-number'}>{ position }</td>)
            }
            return cells
        }
    return(
                <div className={'linear-key'}>
                    <table cellSpacing="0">
                        <tbody>
                            <tr className={'notes'}>
                                {getNoteCells()}
                            </tr>
                            <tr className={'numbers'}>
                                {getPositionCells()}
                            </tr>
                        </tbody>
                    </table>
                </div>
    )
}